import CrudRequest from '@rootCommon/services/crud-request';
import { FHQ_BRANDING_RECORD } from '@rootCommon/constants/end-points';
import { ADMIN } from '@rootCommon/constants/common';
import { FhqBranding, FhqBrandingDto } from '@rootCommon/types/branding';
import { IdType } from '@rootCommon/types/common';

const FHQ_BRANDING_ADMIN = `${FHQ_BRANDING_RECORD}/${ADMIN}`;

class FhqBrandingService extends CrudRequest<FhqBranding, FhqBrandingDto> {
  constructor() {
    super(FHQ_BRANDING_ADMIN);
  }

  getListBySiteId = async (siteId: IdType): Promise<FhqBranding> => {
    const res = await CrudRequest.get<FhqBranding>(FHQ_BRANDING_ADMIN, {
      params: { siteId },
    });

    return res.data;
  };
}

export default new FhqBrandingService();
